import React from "react";

import Loader from "components/Loader";
import Markdown from "components/Markdown";
import Text from "components/Text";
import { useParams } from "hooks/useParam";
import { useInPersonPayableAccount } from "queries/payableAccounts";
import { useRequirementBySlug } from "queries/requirements";

import PaymentLayout from "./PaymentLayout";
import Section from "./Section";
import useOnNext from "./useOnNext";

export const InPersonPaymentInstructions = ({ requirement }) => {
  const { isLoading, data: { instructions: paymentInstructions } = {} } = useInPersonPayableAccount(
    requirement.in_person_payable_account_id,
  );

  return (
    <>
      {isLoading ? <Loader /> : <Markdown source={paymentInstructions} />}
      <h4>
        <Text t="projects.requirement.payment.in_person.instructions" />
      </h4>
    </>
  );
};

const InPersonPayment = ({ paymentType, setPaymentType }) => {
  const { requirementSlug } = useParams();
  const { data: requirement } = useRequirementBySlug(requirementSlug);

  const { onNext, isLoading } = useOnNext({ paymentType, shouldSubmit: true });

  return (
    <PaymentLayout
      paymentType={paymentType}
      setPaymentType={setPaymentType}
      onNext={onNext}
      isLoading={isLoading}
    >
      <Section headerTextKey="projects.requirement.payment.in_person.header">
        <InPersonPaymentInstructions requirement={requirement} />
      </Section>
    </PaymentLayout>
  );
};

export default InPersonPayment;
